import { Block, Flex, Icon, Tooltip } from '@aloft/toolkit-sui';

import { TwoLineCell } from '../../../Grid/TwoLineCell.tsx';
import { PropertyPinIcon } from '../../../PropertyPin.tsx';
import { CompSelectionProperty } from '../../types.ts';
import { getPinColor } from './getPinColor.ts';

export const AddressColumn = (property: CompSelectionProperty) => {
  const { address, id, similarityRank, reo, shortSale, mlsStatus, hasMultipleListings } = property;
  const { AddressLineText, CityName, StateCode, PostalCode } = address ?? {};

  const warningMessages: string[] = [];
  if (reo) warningMessages.push('This is a REO transaction');
  if (shortSale) warningMessages.push('This is a short sale transaction');

  return (
    <Flex justifyContent="space-between" alignItems="center" width="100%" gap="8px">
      <Flex height="100%" alignItems="center" justifyContent="center" flexShrink={0}>
        <PropertyPinIcon
          propertyId={id}
          color={getPinColor(mlsStatus)}
          text={similarityRank?.toString()}
        />
      </Flex>
      <Block paddingRight={2} flexGrow={1} minWidth={0}>
        <TwoLineCell
          line1={AddressLineText ?? ''}
          line2={`${CityName}, ${StateCode} ${PostalCode}`}
        />
      </Block>
      {(reo || shortSale || hasMultipleListings) && (
        <Flex alignItems="center" gap="4px" flexShrink={0}>
          {(reo || shortSale) && (
            <Tooltip label={warningMessages.join('\n')} whiteSpace="pre-line">
              <Icon icon="error-warning" size="md" color="statusWarning" />
            </Tooltip>
          )}
          {hasMultipleListings && (
            <Tooltip label="This address appears more than once in the recommended comps list">
              <Icon icon="error-warning" size="md" color="alertWarning" />
            </Tooltip>
          )}
        </Flex>
      )}
    </Flex>
  );
};
